const binding = { modules: {}, dataActions: {} };

    (binding.modules['cus-new-search'] = {
        c: () => require('partner/modules/cus-new-search/cus-new-search.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cus-new-search',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cus-new-search'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };